import { render, staticRenderFns } from "./SponsorDialogContent.vue?vue&type=template&id=09d81ff8&scoped=true&"
import script from "./SponsorDialogContent.vue?vue&type=script&lang=js&"
export * from "./SponsorDialogContent.vue?vue&type=script&lang=js&"
import style0 from "./SponsorDialogContent.vue?vue&type=style&index=0&id=09d81ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d81ff8",
  null
  
)

export default component.exports